import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { mtBrokerDetailStore } from '@/store/MotorTradeFormStore'
import { useAuthBackOffice } from '@/common/auth/useAuthBackoffice'

const backOfficeBaseURL = import.meta.env.VITE_BACKOFFICE_URL
const backOfficeDashboardURL = backOfficeBaseURL + 'back-office/dashboard'
export const MTBackOfficeRibbon = () => {
  const email = useMemo(useAuthBackOffice, [])
  const { broker } = mtBrokerDetailStore()
  const { t } = useTranslation()
  const returnDashboard = () => {
    sessionStorage.clear()
  }

  return (
    <div className="instantQuoteBackOfficeInfo">
      <div>
        <span>
          {broker?.brokerName ? (
            <span>
              Logged in as <strong>{email}</strong> . Creating a quote for{' '}
              <strong>
                {decodeURIComponent(broker.brokerName.replace(/\+/g, ' '))}
              </strong>
            </span>
          ) : (
            <span>
              You are on a <strong>back-office quote process</strong> and
              currently logged in as {email}
            </span>
          )}
        </span>
        <a href={backOfficeDashboardURL} onClick={returnDashboard}>
          {t('common.return_dashboard')}
        </a>
      </div>
    </div>
  )
}
